module.exports = __webpack_public_path__ + "img/003.127e2254.png";